import { render, staticRenderFns } from "./visao-geral-etiqueta.vue?vue&type=template&id=fe9c1648&scoped=true"
import script from "./visao-geral-etiqueta.vue?vue&type=script&lang=js"
export * from "./visao-geral-etiqueta.vue?vue&type=script&lang=js"
import style0 from "./visao-geral-etiqueta.vue?vue&type=style&index=0&id=fe9c1648&prod&lang=css"
import style1 from "./visao-geral-etiqueta.vue?vue&type=style&index=1&id=fe9c1648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9c1648",
  null
  
)

export default component.exports